import {useEffect, useRef} from 'react';

import {isNil} from 'ramda';

export function useTimeout(callback: () => void, delay: number | null) {
  const savedCallback = useRef(callback);

  // Remember the latest callback if it changes.
  useEffect(
    function saveLatestCallback() {
      savedCallback.current = callback;
    },
    [callback]
  );

  // Set up the timeout.
  useEffect(
    function scheduleTimeout() {
      // Don't schedule if no delay is specified.
      // Note: 0 is a valid value for delay.
      if (isNil(delay) && delay !== 0) {
        return;
      }

      const id = setTimeout(() => savedCallback.current(), delay);

      return () => clearTimeout(id);
    },
    [delay]
  );
}
